<template>
  <div>
    <v-dialog
      v-model="localShowConfirmationDialog"
      max-width="600"
      persistent
      @input="emitDialogChange"
    >
      <v-card :color="$vuetify.theme.currentTheme.navigationColor" class="pt-4">
        <v-card-title class="text-h5 justify-center">
          {{ confirmationTitle }}
        </v-card-title>
        <div class="flex flex-col justify-center items-center p-2" v-if="dialogLable === 'delete'">
          <v-checkbox
            :color="$vuetify.theme.currentTheme.primary"
            v-model="localDeleteCustomer"
            @change="emitCheckboxChange"
            :label="confirmationCustomerMessage"
            hide-details
            class="text-center"
          ></v-checkbox>
          <div class="flex" v-if="localDeleteCustomer">
            <v-icon color="warning" small>mdi-shield-alert-outline</v-icon>
            <p class="text-center flex items-center warning-text p-1 mb-0">
              {{ afterConfirmationMessage }}
            </p>
          </div>
        </div>
        <v-card-text class="text-center">
          {{ confirmationMessage }}
          <div v-if="hasDataCount" class="mt-4 p-3 warning-background rounded">
            <v-icon color="warning" class="mb-2">mdi-alert-circle-outline</v-icon>
            <p class="warning-text mb-2 font-weight-bold">Data Migration Required</p>
            <p class="text-sm">
              This action cannot be undone. Please ensure all data is properly migrated before
              proceeding.
            </p>
          </div>
          <!-- Error message display -->
          <div v-if="errorMessage" class="mt-4 p-3 error-background rounded">
            <v-icon color="error" class="mb-2">mdi-alert-circle-outline</v-icon>
            <p class="error-text mb-2 font-weight-bold">Error</p>
            <p class="text-sm">{{ errorMessage }}</p>
          </div>
        </v-card-text>
        <v-card-actions class="flex mb-2 justify-end w-full">
          <!-- Show only cancel button when there's an error -->
          <v-btn
            outlined
            class="mr-2"
            @click="cancel"
            v-if="confirmationActionText !== 'Logout' && !errorMessage"
          >
            <span class="text-black dark-text-color">{{ cancelActionText }}</span>
          </v-btn>
          <!-- Always show cancel button when there's an error -->
          <v-btn outlined class="mr-2" @click="cancel" v-if="errorMessage">
            <span class="text-black dark-text-color">{{ cancelActionText }}</span>
          </v-btn>
          <v-btn
            :color="confirmationActionColor"
            class="white--text"
            @click="performAction"
            :loading="loading"
            :disabled="hasDataCount || !!errorMessage"
            v-if="!errorMessage"
          >
            {{ confirmationActionText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localShowConfirmationDialog: this.showConfirmationDialog,
      localDeleteCustomer: this.deleteCustomer
    }
  },
  watch: {
    showConfirmationDialog(val) {
      this.localShowConfirmationDialog = val
    },
    deleteCustomer(val) {
      this.localDeleteCustomer = val
    }
  },
  props: {
    confirmationTitle: String,
    showConfirmationDialog: Boolean,
    confirmationMessage: String,
    confirmationActionText: String,
    cancelActionText: { type: String, default: 'Cancel' },
    confirmationActionColor: String,
    cancel: Function,
    performAction: Function,
    dialogLable: String,
    confirmationCustomerMessage: String,
    deleteCustomerFunc: Function,
    loading: Boolean,
    afterConfirmationMessage: String,
    deleteCustomer: Boolean,
    hasDataCount: Boolean,
    // New prop for error messages
    errorMessage: String
  },
  methods: {
    emitCheckboxChange() {
      this.$emit('update:deleteCustomer', this.localDeleteCustomer)
    },
    emitDialogChange() {
      this.$emit('update:showConfirmationDialog', this.localShowConfirmationDialog)
    }
  }
}
</script>

<style scoped>
.warning-text {
  color: #fb8c00;
  font-size: 12px;
}
.error-text {
  color: #ff5252;
  font-size: 12px;
}

.warning-background {
  background-color: #fff3e0;
  border: 1px solid #ffcc02;
}
.error-background {
  background-color: #ffebee;
  border: 1px solid #ff5252;
}
</style>
